import React from "react";
import tw, { styled } from "twin.macro";
import DynamicContainer from "./DynamicContainer";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import Carousel from "nuka-carousel/lib/carousel";
import _ from "lodash";
import { getContrastText } from "../utils";
import Icon from "./Icon";

const Container = styled.div`
  ${tw`min-h-[500px] bg-black mt-32 pb-2 relative`}
`;
const AngledContainer = styled.div`
  ${tw`absolute -top-16 left-0 w-full h-32 bg-black -skew-y-2 -z-10`}
`;

const ContentContainer = styled(DynamicContainer)`
  ${tw`sm:pt-12 grid grid-cols-1 lg:grid-cols-[minmax(0,1fr),minmax(0, 1fr)] xl:grid-cols-[minmax(0,1fr),minmax(0, 2fr)] gap-x-8`}
`;
const TextContainer = styled.div`
  ${tw``}
`;
const Header = styled.div`
  ${tw`font-bold text-2xl md:text-5xl text-white`}
`;
const SubHeader = styled.div`
  ${tw`font-bold text-xl md:text-4xl text-[#9561a9] sm:mt-2`}
`;
const HeaderDescription = styled.div`
  ${tw`text-white  font-bold mt-2 sm:mt-4 text-lg`}
`;
const HeaderSubDescription = styled.div`
  ${tw`text-white  font-bold mt-2 sm:mt-4 text-lg`}
`;
// const Phone = styled.a`
//   ${tw`text-white  font-bold text-lg`}
// `
// const Email = styled.a`
//   ${tw`text-white block font-bold mt-2 sm:mt-4 text-lg`}
// `

const ButtonContainer = styled.div`
  ${tw`flex flex-col mt-8`}
`;

const ButtonLink = styled.a`
  ${tw`
    block w-[160px] rounded-lg  
    px-3 py-2 mt-3 mr-4
    font-bold text-center text-lg uppercase
    hover:opacity-80 transition-[opacity] duration-200
  `}

  background-color: ${({ bgColor }) => (bgColor ? bgColor : "#000000")};
  color: ${({ bgColor }) => (bgColor ? getContrastText(bgColor) : "#ffffff")};
`;
const SlideButtonLink = styled.a`
  ${tw`
  block w-[160px] rounded-lg  
  px-3 py-2 mt-5 sm:mt-5 mr-4 ml-6 sm:ml-0
  font-bold text-center text-lg uppercase
  hover:opacity-80 transition-[opacity] duration-200
  `}

  background-color: ${({ bgColor }) => (bgColor ? bgColor : "#000000")};
  color: ${({ bgColor }) => (bgColor ? getContrastText(bgColor) : "#ffffff")};
`;

const SlideshowHeader = styled.div`
  ${tw`text-2xl md:text-5xl text-white mb-4 ml-4 font-bold`}
`;

const SliderContainer = styled.div`
  ${tw`mb-8 mt-8 lg:mt-0`}
`;
const LeftButton = styled.button`
  ${tw`absolute -left-4 sm:-left-7 top-0 w-9 h-9 bottom-0 my-auto text-white disabled:text-[#9561a9]`}
  & > .material-icons {
    ${tw`text-4xl`}
  }
`;
const RightButton = styled.button`
  ${tw`absolute -right-4 sm:-right-7 top-0 w-9 h-9 bottom-0 my-auto text-white disabled:opacity-20`}
  & > .material-icons {
    ${tw`text-4xl`}
  }
`;
const BottomPagingContainer = styled.div`
  ${tw`absolute bottom-[-20px] left-0 right-0 flex justify-center`}
`;
const PagingButton = styled.div`
  ${tw`block w-5 h-1.5 mx-2.5 rounded cursor-pointer`}
  background-color: ${({ isCurrentSlide }) =>
    isCurrentSlide ? tw`bg-[#9561a9]` : "#bdbdbd"};
`;

const SliderItem = styled.div`
  ${tw`relative mx-4 mb-2 bg-[#9561a9]`}
  box-shadow: 0px 2px 8px 0px #121212;
`;
const ImageContainer = styled.div`
  ${tw`h-[300px]`}
`;
const InfoContainer = styled.div`
  ${tw`flex flex-col mt-4 pb-6`}
`;
const Attributes = styled.div`
  ${tw`mx-2 sm:mx-6 grid grid-cols-2 md:grid-cols-4`}
`;
const AttributeItem = styled.div`
  ${tw`flex items-center text-base sm:text-lg text-white font-bold whitespace-nowrap overflow-hidden text-ellipsis`}
  & > div {
    ${tw`opacity-60`}
  }
  & > .material-icons {
    ${tw`mr-1.5 text-black`}
  }
`;
const Title = styled.div`
  ${tw`px-6 border-l-4 border-black mt-4 text-white text-3xl font-bold max-h-16 overflow-y-hidden text-ellipsis`}
`;
const BottomContainer = styled.div`
  ${tw`flex flex-col sm:flex-row justify-between sm:items-center w-full`}
`;

const Sponsors = ({ color, site, data }) => {
  const {
    slideshowHeader,
    header,
    subHeader,
    description,
    subDescription,
    phone,
    email,
    // tourLink,
    list,
  } = data.markdownRemark.frontmatter.sponsorslides;
  // calculate slides to show based on screen width

  // const headerWordsArray = header.split(" ")
  // const restOfHeader = headerWordsArray
  //   .slice(0, headerWordsArray.length - 1)
  //   .join(" ")
  // const lastWordOfHeader = headerWordsArray
  //   .slice(headerWordsArray.length - 1, headerWordsArray.length)
  //   .join(" ")

  return (
    <Container>
      <AngledContainer />
      <ContentContainer>
        <TextContainer>
          <Header color={color} site={site}>
            {header}
          </Header>
          {subHeader && <SubHeader>{subHeader}</SubHeader>}
          {description && <HeaderDescription>{description}</HeaderDescription>}
          {subDescription && (
            <HeaderSubDescription>{subDescription}</HeaderSubDescription>
          )}
          <ButtonContainer>
            {phone && (
              <ButtonLink bgColor="#9561a9" href={`tel:${phone}`}>
                Call Us
              </ButtonLink>
            )}
            {email && (
              <ButtonLink bgColor="#9561a9" href={`mailto:${email}`}>
                Email Us
              </ButtonLink>
            )}
          </ButtonContainer>
        </TextContainer>
        <SliderContainer>
          <SlideshowHeader>{slideshowHeader}</SlideshowHeader>
          {!_.isEmpty(list) && (
            <Carousel
              autoplay={false}
              // autoplayInterval={5000}
              wrapAround={true} //loops back to first slide when it reaches the end
              slidesToShow={1}
              renderBottomCenterControls={({
                goToSlide,
                currentSlide,
                pagingDotsIndices,
              }) => {
                return (
                  <BottomPagingContainer>
                    {pagingDotsIndices.map((indice) => (
                      <PagingButton
                        key={indice}
                        isCurrentSlide={indice === currentSlide}
                        onClick={() => goToSlide(indice)}
                      />
                    ))}
                  </BottomPagingContainer>
                );
              }}
              renderCenterLeftControls={({ previousSlide }) => (
                <LeftButton onClick={previousSlide}>
                  <Icon name="chevron_left" />
                </LeftButton>
              )}
              renderCenterRightControls={({ nextSlide }) => (
                <RightButton onClick={nextSlide}>
                  <Icon name="chevron_right" />
                </RightButton>
              )}
              slideIndex={0}
            >
              {list.map((item, idx) => {
                const { title, image } = item;
                return (
                  <SliderItem key={idx}>
                    <ImageContainer>
                      <GatsbyImage
                        image={getImage(image)}
                        alt="group_bookings_image"
                        style={{ width: "100%", height: "100%" }}
                        imgStyle={{ width: "100%", height: "100%" }}
                        objectFit="cover"
                        objectPosition="50% 50%"
                      />
                    </ImageContainer>
                    <InfoContainer>
                      {/* <Attributes>
                        <AttributeItem>
                          <Icon name="group" />
                          <div>{groupSize}</div>
                        </AttributeItem>
                        <AttributeItem>
                          <Icon name="sell" />
                          <div>{price}</div>
                        </AttributeItem>
                        <AttributeItem>
                          <Icon name="location_on" />
                          <div>{location}</div>
                        </AttributeItem>
                        <AttributeItem>
                          <Icon name="tour" />
                          <div>{location2}</div>
                        </AttributeItem>
                      </Attributes> */}

                      <BottomContainer>
                        <Title>{title}</Title>
                      </BottomContainer>
                    </InfoContainer>
                  </SliderItem>
                );
              })}
            </Carousel>
          )}
        </SliderContainer>
      </ContentContainer>
    </Container>
  );
};

export default Sponsors;
